export default __webpack_public_path__ + "static/media/IMG_5181.82b04032.jpeg";